import {directive as onClickaway} from 'vue-clickaway';
import {mapActions, mapGetters, mapMutations} from 'vuex';

import VideoPlayer from "@/components/video-player/index.vue";
import lessonSidebar from '../../components/lesson-sidebar/index.vue'
import materialSidebar from '../../components/material-sidebar/index.vue'
import additionalMaterials from '@/components/features/additional-materials/index.vue';
import notice from '@/components/features/notice/index.vue';
import speakersMobile from '@/components/atoms/speakers-education-mobile/index.vue';

import {seo} from '@/mixins/seo'

export default {
    name: 'course-material-detail',
    mixins: [seo],
    directives: {
        onClickaway: onClickaway,
    },
    props: {},
    data() {
        return {
            active: false,
            value: '',
        }
    },
    components: {
        VideoPlayer,
        lessonSidebar,
        additionalMaterials,
        notice,
        speakersMobile,
        materialSidebar
    },
    beforeRouteLeave(to, from, next) {
        if (to.params.materialType !== from.params.materialType) {
            this.setList([])
        }
        next()
    },
    computed: {
        ...mapGetters({
            currentItem: 'coursesMaterials/currentItem',
            isLoading: 'coursesMaterials/isCurrentItemLoading',
            selectedVideoId: 'coursesMaterials/selectedVideoId',
        }),
    },
    created() {
        this.fetchContent(this.$route.params).then(() => {
            Object.assign(this.seo, this.currentItem.seo.data)
            this.$emit('updateHead')
        })
        this.getComponents({slug: this.$route.params.item})
    },
    methods: {
        ...mapActions({
            fetchContent: 'coursesMaterials/FETCH_MATERIALS_ITEM',
            getComponents: 'courses/GET_COMPONENTS'
        }),
        ...mapMutations({
            setList: 'coursesMaterials/MATERIALS_SET_LIST',
            setCurrentItem: 'coursesMaterials/MATERIALS_SET_ITEM'
        }),
        close() {
            this.active = false;
        },
        setValue(value) {
            this.value = value;
            this.active = false;
        }
    },
    destroyed() {
        this.setCurrentItem(null)
    }
}
